export interface DealRequestAllocation {
	guid: string;
	dealGuid: string;
	acquiringBusiness?: boolean;
	debtCapitalForBusiness?: boolean;
	dealType?: DealType;
	percentageBeingPurchased?: number;
	hasCurrentOwnership?: boolean;
	currentOwnershipPercentage?: number;
	confirmRollingAmount?: boolean;
	valueOfferedAmount?: number;
	sellerEquityRollAmount?: number;
	provideSellerFinancing?: boolean;
	sellerFinancingAmount?: number;
	buyerProvidingCash?: boolean;
	buyerCashAmount?: number;
	hasEarnout?: boolean;
	earnoutAmount?: number;
	workingCapitalForAcquisition?: boolean;
	workingCapitalForAcquisitionAmount?: number;
	acquisitionEvaluationStage?: AcquisitionEvaluationStage;
	natureOfBuyer?: NatureOfBuyerType;
	transactionType?: AcquisitionTransactionType;
	acquisitionYearsInOperation?: number;
	hasLegalCouncel?: boolean;
	legalFirmName?: string;
	refinanceExistingDebt?: boolean;
	purchaseEquipment?: boolean;
	purchaseEquipmentAmount?: number;
	equipmentDescription?: string;
	purchaseRealEstate?: boolean;
	manageCapitalOrLiquidity?: boolean;
	averageMonthlyArBalanceAmount?: number;
	purchaseInventory?: boolean;
	financeExpensesOrGrowth?: boolean;
	hiringDevelopmentAmount?: number;
	hiringProviderAmount?: number;
	hiringExecutiveAmount?: number;
	costsNewLocationsAmount?: number;
	leaseholdImprovementAmount?: number;
	furnitureFixturesAmount?: number;
	researchDevelopmentAmount?: number;
	softwareTechnologyAmount?: number;
	otherFinancingNeeds?: boolean;
	otherFinancingAmount?: number;
	otherFinancingDescription?: string;
	purchaseVehiclesAmount?: number;
	purchaseMarineAmount?: number;
	purchaseHelicopterAmount?: number;
	purchaseFixedWingAircraftAmount?: number;
	equipmentAssetType?: ProfileTangibleAssetType;
	vehicleAssetType?: ProfileTangibleAssetType;
	marineAssetType?: ProfileTangibleAssetType;
	helicopterAssetType?: ProfileTangibleAssetType;
	fixedWingAircraftAssetType?: ProfileTangibleAssetType;
	refinanceMaturingSoon?: boolean;
	refinanceLowerRate?: boolean;
	refinanceExtendAmortization?: boolean;
	refinanceIncreaseLoanSize?: boolean;
	refinanceNewLender?: boolean;
	refinanceOther?: boolean;
	purchaseInventoryAmount?: number;
	purchaseWorkingCapital?: boolean;
	allocationInventoryType?: number;
	totalWorkingCapitalAmount?: number;
	totalGrowthCapitalHardCostAmount?: number;
	totalGrowthCapitalSoftCostAmount?: number;
	workingCapitalImproveLiquidity?: boolean;
	workingCapitalPurchaseInventory?: boolean;
	workingCapitalOperatingExpenses?: boolean;

	hasInventory?: boolean | null;
	hasOwnerOccupiedRealEstate?: boolean | null;
	hasFurnitureFixtures?: boolean | null;
	hasMachineryEquipment?: boolean | null;
	hasRollingStock?: boolean | null;
	hasMarineVessels?: boolean | null;
	hasHelicopters?: boolean | null;
	hasFixedWingAircraft?: boolean | null;
	hasRoyaltyLicensingAgreements?: boolean | null;
	hasIntellectualProperty?: boolean | null;
	hasCashMarketables?: boolean | null;
	hasAccountsReceivables?: boolean | null;

	acquisitionHasInventory?: boolean | null;
	acquisitionHasOwnerOccupiedRealEstate?: boolean | null;
	acquisitionHasFurnitureFixtures?: boolean | null;
	acquisitionHasMachineryEquipment?: boolean | null;
	acquisitionHasRollingStock?: boolean | null;
	acquisitionHasMarineVessels?: boolean | null;
	acquisitionHasHelicopters?: boolean | null;
	acquisitionHasFixedWingAircraft?: boolean | null;
	acquisitionHasRoyaltyLicensingAgreements?: boolean | null;
	acquisitionHasIntellectualProperty?: boolean | null;
	acquisitionHasCashMarketables?: boolean | null;
	acquisitionHasAccountsReceivables?: boolean | null;
	cashFlowBankPreference?: boolean | null;
	cashFlowNonBankPreference?: boolean | null;
	juniorCashFlowNonBankPreference?: boolean | null;
	assetBasedArInvBankPreference?: boolean | null;
	assetBasedArInvNonBankPreference?: boolean | null;
	assetBasedFixedAssetsBankPreference?: boolean | null;
	assetBasedFixedAssetsNonBankPreference?: boolean | null;
	smallGovernmentPreference?: boolean | null;
	largeGovernmentPreference?: boolean | null;
	ventureDebtPreference?: boolean | null;
	poFinancingPreference?: boolean | null;
	factoringPreference?: boolean | null;
	unknownPreference?: boolean | null;
	cashFlowBankPreferenceSelected?: boolean | null;
	cashFlowNonBankPreferenceSelected?: boolean | null;
	juniorCashFlowNonBankPreferenceSelected?: boolean | null;
	assetBasedArInvBankPreferenceSelected?: boolean | null;
	assetBasedArInvNonBankPreferenceSelected?: boolean | null;
	assetBasedFixedAssetsBankPreferenceSelected?: boolean | null;
	assetBasedFixedAssetsNonBankPreferenceSelected?: boolean | null;
	smallGovernmentPreferenceSelected?: boolean | null;
	largeGovernmentPreferenceSelected?: boolean | null;
	ventureDebtPreferenceSelected?: boolean | null;
	poFinancingPreferenceSelected?: boolean | null;
	factoringPreferenceSelected?: boolean | null;
	ventureBankNonBankPreference?: boolean | null;
	ventureBankNonBankPreferenceSelected?: boolean | null;
	inventoryOnlyPreference?: boolean | null;
	inventoryOnlyPreferenceSelected?: boolean | null;
	lenderFinanceBankPreference?: boolean | null;
	lenderFinanceBankPreferenceSelected?: boolean | null;
	lenderFinanceNonBankPreference?: boolean | null;
	lenderFinanceNonBankPreferenceSelected?: boolean | null;
	floorplanFinanceBankPreference?: boolean | null;
	floorplanFinanceBankPreferenceSelected?: boolean | null;
	floorplanFinanceNonBankPreference?: boolean | null;
	floorplanFinanceNonBankPreferenceSelected?: boolean | null;
	bridgeLoanNonBankPreference?: boolean | null;
	bridgeLoanNonBankPreferenceSelected?: boolean | null;

	borrowerCollateralNotes: string | null;
	acquisitionCollateralNotes: string | null;
	loanRequestNotes: string | null;

	hasPreference: boolean;
	hasSelectedPreference: boolean;
	totalAcquisitionCapitalNeededAmount: number;
	acquisitionTransactionCostsAmount: number | null;
	acquisitionWorkingCapitalContributionAmount: number | null;
}

export type ProfileTangibleAssetType = keyof typeof ProfileTangibleAssetTypeMap;

export const ProfileTangibleAssetTypeMap = {
	NotApplicable: 'N/A',
	New: 'New',
	Used: 'Used',
};

export type NatureOfBuyerType = keyof typeof NatureOfBuyerTypeMap;

export const NatureOfBuyerTypeMap = {
	NotSelected: 'Not Selected',
	ExistingOwner: 'Existing Owner',
	IndividualNonExistingOwner: 'Individual Non-Existing Owner',
	FundedSponsor: 'Funded Sponsor',
	NonFundedSponsor: 'Non-Funded Sponsor',
	Strategic: 'Strategic',
};

export type AcquisitionTransactionType = keyof typeof AcquisitionTransactionTypeMap;

export const AcquisitionTransactionTypeMap = {
	None: 'Not Yet Determined',
	Asset: 'Asset',
	StockSale: 'Stock Sale',
};

export type AcquisitionEvaluationStage = keyof typeof AcquisitionEvaluationStageMap;

export const AcquisitionEvaluationStageMap = {
	None: 'Not Selected',
	LoiSigned: 'LOI Signed',
	LoiSubmitted: 'LOI Submitted',
	LoiNegotiation: 'Negotiating LOI',
	EarlyStages: 'Early Stages of Evaluation',
};

export type DealType = keyof typeof DealTypeMap;

export const DealTypeMap = {
	RealEstate: 'Owner Occupied Real Estate',
	WorkingCapital: 'Working Capital',
	EquipmentLeasing: 'Equipment',
	Acquisitions: 'Stand-Alone',
	GrowthCapital: 'Growth Capital',
	Recapitalizations: 'Recapitalization',
	Refinancing: 'Refinancing',
	AcquisitionAddon: 'Add-On',
	AcquisitionPartnerBuyout: 'Partner Buy-Out',
	AcquisitionManagementBuyout: 'Management Buy-Out',
	ProjectFinance: 'Project Finance',
	InvestmentRealEstate: 'Investment Real Estate',
};

export const dealPreferences = (value?: DealRequestAllocation) => {
	if (value == undefined) return [];
	var preferences: string[] = [];
	if (value.cashFlowBankPreference) preferences.push('Cash Flow Bank');
	if (value.cashFlowNonBankPreference) preferences.push('Senior Cash Non-Bank Lending');
	if (value.juniorCashFlowNonBankPreference) preferences.push('Junior Cash Non-Bank Lending');
	if (value.assetBasedArInvBankPreference) preferences.push('Asset Based Commercial Bank AR/Inv');
	if (value.assetBasedArInvNonBankPreference) preferences.push('Asset Based Non-Bank Lending AR/Inv');
	if (value.assetBasedFixedAssetsBankPreference) preferences.push('Asset Based Commercial Bank Fixed Assets');
	if (value.assetBasedFixedAssetsNonBankPreference) preferences.push('Asset Based Non-Bank Lending Fixed Assets');
	if (value.smallGovernmentPreference) preferences.push('Small Government Backed Loans');
	if (value.largeGovernmentPreference) preferences.push('Rural Government Backed Loans');
	if (value.ventureDebtPreference) preferences.push('Venture Debt');
	if (value.poFinancingPreference) preferences.push('Purchase Order Financing');
	if (value.factoringPreference) preferences.push('Factoring');
	if (value.ventureBankNonBankPreference) preferences.push('Venture & Recurring Revenue Loans Non-Bank');
	if (value.inventoryOnlyPreference) preferences.push('Asset Based Non-Bank Lending Inventory Only');
	if (value.lenderFinanceBankPreference) preferences.push('Lender Finance - Bank');
	if (value.lenderFinanceNonBankPreference) preferences.push('Lender Finance - Non-Bank');
	if (value.floorplanFinanceBankPreference) preferences.push('Floorplan Finance - Bank');
	if (value.floorplanFinanceNonBankPreference) preferences.push('Floorplan Finance - Non-Bank');
	if (value.bridgeLoanNonBankPreference) preferences.push('Bridge Loan');

	return preferences;
};

export const dealPreferencesSelected = (value?: DealRequestAllocation) => {
	if (value == undefined) return [];
	var preferences: string[] = [];
	if (value.cashFlowBankPreferenceSelected) preferences.push('Cash Flow Bank');
	if (value.cashFlowNonBankPreferenceSelected) preferences.push('Senior Cash Non-Bank Lending');
	if (value.juniorCashFlowNonBankPreferenceSelected) preferences.push('Junior Cash Non-Bank Lending');
	if (value.assetBasedArInvBankPreferenceSelected) preferences.push('Asset Based Commercial Bank AR/Inv');
	if (value.assetBasedArInvNonBankPreferenceSelected) preferences.push('Asset Based Non-Bank Lending AR/Inv');
	if (value.assetBasedFixedAssetsBankPreferenceSelected) preferences.push('Asset Based Commercial Bank Fixed Assets');
	if (value.assetBasedFixedAssetsNonBankPreferenceSelected)
		preferences.push('Asset Based Non-Bank Lending Fixed Assets');
	if (value.smallGovernmentPreferenceSelected) preferences.push('Small Government Backed Loans');
	if (value.largeGovernmentPreferenceSelected) preferences.push('Rural Government Backed Loans');
	if (value.ventureDebtPreferenceSelected) preferences.push('Venture Debt');
	if (value.poFinancingPreferenceSelected) preferences.push('Purchase Order Financing');
	if (value.factoringPreferenceSelected) preferences.push('Factoring');
	if (value.ventureBankNonBankPreferenceSelected) preferences.push('Venture & Recurring Revenue Loans Non-Bank');
	if (value.inventoryOnlyPreferenceSelected) preferences.push('Asset Based Non-Bank Lending Inventory Only');
	if (value.lenderFinanceBankPreferenceSelected) preferences.push('Lender Finance - Bank');
	if (value.lenderFinanceNonBankPreferenceSelected) preferences.push('Lender Finance - Non-Bank');
	if (value.floorplanFinanceBankPreferenceSelected) preferences.push('Floorplan Finance - Bank');
	if (value.floorplanFinanceNonBankPreferenceSelected) preferences.push('Floorplan Finance - Non-Bank');
	if (value.bridgeLoanNonBankPreferenceSelected) preferences.push('Bridge Loan');

	return preferences;
};
